export default __webpack_public_path__ + "static/media/closet4-2048w.6ab1a7d7.png";